<ng-container *ngIf="phase">
    <div class="line primera">
        <shared-exwork-slot-viewer-component [driver]="true" [slotInfo]="phase.slotInfo" [phaseId]="phase.phaseId"
            class="element" [allowNextView]="false"></shared-exwork-slot-viewer-component>
        <div class="requadre load element paddingtop" *ngIf="phase.isLoad">{{'PHASE.ISLOAD'| translate}}</div>
        <div class="requadre unload element paddingtop" *ngIf="phase.isUnload">{{'PHASE.ISUNLOAD'| translate}}</div>
        <div class="requadre unloadload element paddingtop" *ngIf="phase.isUnloadLoad">{{'PHASE.ISUNLOADLOAD'|
            translate}}
        </div>
        <shared-tags-strip-component class="tags element paddingtop asrequadre"
            [uniqueString]="phase.addressSkin"></shared-tags-strip-component>
    </div>

    <span class="line address">{{phase.formattedAddress}}</span>
    <shared-tags-strip-component class="line onlytags tags sangrat" [tags]="phase.userTags"
        [applyColor]="false"></shared-tags-strip-component>

    <div class="line goods sangrat">
        {{phase.goods}}
    </div>
</ng-container>